import useMainComponent from "./main";

const useComponents = () => {
    return {
        useMainComponent
    }
}

export default useComponents